"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMachine = exports.useCallbackTrackEvent = exports.useViewTrackEvent = exports.useTranslate = exports.useHover = exports.useStore = exports.useInterval = void 0;
const i18n_1 = require("@c3po/i18n");
const provider_1 = require("@cart/provider");
const react_1 = require("react");
const track_1 = require("../contexts/track");
const useInterval = (callback, delay, resetCondition) => {
    const [intervalId, setIntervalId] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const id = setInterval(callback, delay);
        setIntervalId(id);
        return () => clearInterval(id);
    }, resetCondition);
    return () => clearInterval(intervalId);
};
exports.useInterval = useInterval;
const useStore = () => {
    const { getState, getCartConnected } = (0, provider_1.useCartActions)();
    const store = getState();
    (0, react_1.useEffect)(() => {
        getCartConnected();
    }, []);
    return store;
};
exports.useStore = useStore;
const useHover = () => {
    const [timeoutId, setTimeoutId] = (0, react_1.useState)(null);
    const clearHoverTimeout = () => {
        if (timeoutId)
            clearTimeout(timeoutId);
        setTimeoutId(null);
    };
    const leaveHover = () => {
        if (timeoutId)
            clearHoverTimeout();
    };
    const enterHover = (onHover) => {
        if (timeoutId)
            clearHoverTimeout();
        setTimeoutId(setTimeout(onHover, 300));
    };
    return { enterHover, leaveHover };
};
exports.useHover = useHover;
const useTranslate = () => {
    var _a;
    const translation = (0, i18n_1.useTranslate)();
    const defaultI18n = (key) => key;
    if (!translation)
        return {
            i18n: defaultI18n,
        };
    return Object.assign(Object.assign({}, translation), { i18n: (_a = translation.i18n) !== null && _a !== void 0 ? _a : defaultI18n });
};
exports.useTranslate = useTranslate;
const useViewTrackEvent = (callback, ...args) => {
    const { track } = (0, track_1.useTrack)();
    (0, react_1.useEffect)(() => {
        track(...callback(...args));
    }, []);
};
exports.useViewTrackEvent = useViewTrackEvent;
const useCallbackTrackEvent = () => {
    const { track } = (0, track_1.useTrack)();
    return (0, react_1.useCallback)((event) => track(...event), []);
};
exports.useCallbackTrackEvent = useCallbackTrackEvent;
const reducerFactory = (machine) => (state, action) => {
    const value = machine.states[state.value].on[action];
    return value ? Object.assign(Object.assign({}, state), { value }) : state;
};
const useMachine = (machine) => (0, react_1.useReducer)(reducerFactory(machine), { value: machine.initial });
exports.useMachine = useMachine;
